import { render, staticRenderFns } from "./Caratteristiche2.vue?vue&type=template&id=1b003d69&"
import script from "./Caratteristiche2.vue?vue&type=script&lang=js&"
export * from "./Caratteristiche2.vue?vue&type=script&lang=js&"
import style0 from "./Caratteristiche2.vue?vue&type=style&index=0&id=1b003d69&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports